import { ElasticCollection } from "@usereactify/search";
import React, { useMemo } from "react";
import { ResultStatsProvider } from "../context/ResultStatsContext";
import { ViewSettingsProvider } from "../context/ViewSettingsContext";
import { CollectionCustomFields, ColorGroup } from "../reactify";
import { Filters } from "./Filters/Filters";
import { Results } from "./Results/Results";

export type CollectionProps = {
  collection: ElasticCollection;
  colorGroups: ColorGroup[] | null;
  collectionCustomFields: CollectionCustomFields;
};

export const Collection: React.FC<CollectionProps> = (props) => {
  const memoizedColorGroups = useMemo(() => props.colorGroups, [props.colorGroups]);

  return (
    <div>
      <ViewSettingsProvider>
        <ResultStatsProvider>
          <div className="medium-up--one-whole grid__item--sidebar">
            <div id="CollectionSidebar">
              <div className="collection-sidebar small--hide" id="CollectionSidebarFilterWrap">
                <Filters mobile={false} />
              </div>
            </div>

            <div className="collection-filter__item collection-filter__item--left medium-up--hide w-full">
              <Filters mobile={true} />
            </div>

            <Results colorGroups={memoizedColorGroups} pageSize={40} />
          </div>
        </ResultStatsProvider>
      </ViewSettingsProvider>
    </div>
  );
};
